export enum FeatureFlags {
  teamChatHuddles = 'teamChatHuddles',
  telehealthHuddles = 'telehealthHuddles',
  reportSnapshots = 'reportSnapshots',
  claimRejectionsReport = 'claimRejectionsReport',
  serviceLineLevelBilling = 'serviceLineLevelBilling',
  /** Patient-record-level Claim Info (table, resolver, snapshots, UI). */
  patientRecordClaimInfo = 'patientRecordClaimInfo',
  turnOffTracks = 'turnOffTracks',
  memberships = 'memberships',
  aiReceptionist = 'aiReceptionist',
  clinicWidgets = 'clinicWidgets',
  massTexting = 'massTexting',
  /** Redesigned Settings > Subscription page; off renders the pre-redesign page. */
  subscriptionRedesign = 'subscriptionRedesign',
  saopWizardNavigation = 'saopWizardNavigation',
  creditCardInformationRequest = 'creditCardInformationRequest',
  /** Reset an insurance policy for a new period (button + auto-reset setting + policy activity log). */
  insurancePolicyReset = 'insurancePolicyReset',
}

export enum FlagGroups {
  everyone = 'everyone',
  beta = 'beta',
  alpha = 'alpha',
  internal = 'internal',
}

export const flagGroupsArr = [
  {
    label: 'Internal',
    value: 'internal',
  },
  {
    label: 'Alpha',
    value: 'alpha',
  },
  {
    label: 'Beta',
    value: 'beta',
  },
  {
    label: 'Everyone',
    value: 'everyone',
  },
];
